import { defineMessages } from 'react-intl';

export const a2aSiteSelectorMessages = defineMessages({
  siteLabel: {
    id: 'oauth.a2a.siteSelector.label',
    defaultMessage: 'Authorize access for:',
    description: 'Label above the site-picker dropdown',
  },
  sitePlaceholder: {
    id: 'oauth.a2a.siteSelector.placeholder',
    defaultMessage: 'Select a site',
    description: 'Placeholder text inside the site-picker dropdown',
  },
  noWorkspacesHeading: {
    id: 'oauth.a2a.siteSelector.noWorkspaces.heading',
    defaultMessage: 'Supported sites required',
    description:
      'Heading shown when the user has no workspaces available in their token',
  },
  noWorkspacesDescription: {
    id: 'oauth.a2a.siteSelector.noWorkspaces.description',
    defaultMessage:
      'Atlassian Rovo MCP connects with Atlassian sites that use apps like Jira or Confluence. Your account isn\'t currently associated with a supported site.  {learnMoreLink}',
    description:
      'Description shown when the user has no workspaces; {learnMoreLink} is a link to documentation',
  },
  noWorkspacesLearnMore: {
    id: 'oauth.a2a.siteSelector.noWorkspaces.learnMore',
    defaultMessage: 'Learn more',
    description:
      'Link text for the documentation shown when no workspaces are available',
  },
});
